module.exports = __webpack_public_path__ + "static/media/selectArrowDown.73175664.svg";